import { Box } from '@mui/material';
import { MatchPlayerStatus, MatchStatus } from '@okletsplay/core';
import { MatchPlayer, UserEntity } from 'app/interfaces/entity';
import { sessionSelector } from 'app/store/session/selectors';
import { PlayerTile } from 'modules/users/components/PlayerTile/PlayerTile';
import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useDefaultUserMenuActions } from 'shared/hooks';
import { useStyles } from './MatchPlayers.styles';
import { useStyles as useScrollStyles } from 'shared/styles/ScrollBar.styles';
import classNames from 'classnames';

interface PlayersProps {
  players: MatchPlayer[];
  matchStatus?: MatchStatus;
}

export const MatchPlayers: FC<PlayersProps> = ({ players = [], matchStatus }) => {
  const { classes } = useStyles();
  const { classes: scrollBarClasses } = useScrollStyles();
  const activeUser = useSelector(sessionSelector.activeUser) as UserEntity;
  const { privateMessageActions } = useDefaultUserMenuActions();

  const opponents = useMemo(() => {
    if (matchStatus === MatchStatus.Declined) {
      return players
        .filter((player) =>
          [MatchPlayerStatus.Declined, MatchPlayerStatus.Ready].includes(player.status)
        )
        .map((player) => player.user);
    }

    return players
      .filter((player) => player.status !== MatchPlayerStatus.Declined)
      .map((player) => player.user);
  }, [players, matchStatus]);

  const getPlayerActions = (player: UserEntity | undefined) =>
    player && player?.id === activeUser?.id ? [] : privateMessageActions;

  return (
    <Box className={classNames(classes.listContainer, scrollBarClasses.vertical)}>
      {opponents.map((user) => (
        <React.Fragment key={user.userId}>
          <Box className={classes.player} mb={2}>
            <PlayerTile user={user} actions={getPlayerActions(user)} />
          </Box>
        </React.Fragment>
      ))}
    </Box>
  );
};
